/**
 * Created by Vladislav on 03.06.2025.
 */

Mission.TYPE_BONUS_WORLD = 19;

Mission.REGISTRATIONS.set(Mission.TYPE_BONUS_WORLD, () => ({
    prize: RewardsConfig.Tournament.places,
    teaser: true,
    name: "BonusWorld",
    startWindow: BonusWorldWindow,
    view: bundles.main.jsons.bonusworldscene_prefab_json,
    available: cleverapps.config.availables.BONUS_WORLD_MISSION,
    logic: BonusWorldMissionLogic,
    sideBarJson: BonusWorldConfig.xmas.sideBarJson,
    feature: "bonusworld",
    oncePerEvent: !cleverapps.config.debugMode,
    iconForce: Forces.BONUS_WORLD
}));
